(function() {
  'use strict';

  if (window.MrMapleCareGuideZone && window.MrMapleCareGuideZone.version) return;

  var zipClimate = window.MrMapleZipClimate;
  var autoLookupStarted = false;
  var profileZipLookupStarted = false;
  var careMapCache = {
    markupByUrl: {},
    promiseByUrl: {}
  };
  var nextCareMapInstanceId = 1;
  var MOBILE_PANEL_MEDIA = '(max-width: 680px)';
  var CARE_ZONE_MAP_FOCUS_ZOOM = 2;

  var ZONE_GROUP_LABELS = {
    'default': 'General care until a zone is selected.',
    'colder-than-range': 'Colder-zone guidance: protect roots, shelter from freeze-thaw swings, and consider a container that can move into an unheated protected space.',
    'cold-edge': 'Zone 5 guidance: shelter from wind, mulch roots, and watch late frosts.',
    'core': 'Zones 6-7 guidance: balanced sun, steady moisture, and routine maintenance.',
    'warm-edge': 'Zone 8 guidance: afternoon shade, deep watering, airflow, and cool roots.',
    'heat-edge': 'Zone 9 guidance: filtered light, consistent irrigation, no reflected heat, and heat-index awareness.',
    'warmer-than-range': 'Warmer-zone guidance: USDA zone only measures winter cold; Zone 10+ viability depends on summer heat index, humidity, shade, and heat-rated cultivars.'
  };

  function getZipApi() {
    return window.MrMapleZipClimate || zipClimate;
  }

  function normalizeZoneLetter(letter) {
    return letter === 'a' || letter === 'b' ? letter : '';
  }

  function zoneIndex(number, letter, isUpperBound) {
    var n = parseInt(number, 10);
    if (isNaN(n) || n < 1 || n > 13) return null;
    var normalizedLetter = normalizeZoneLetter(letter);
    if (!normalizedLetter) {
      return (n * 2) - (isUpperBound ? 0 : 1);
    }
    return (n * 2) - (normalizedLetter === 'a' ? 1 : 0);
  }

  function zonePartsFromIndex(index) {
    var normalizedIndex = parseInt(index, 10);
    if (isNaN(normalizedIndex) || normalizedIndex < 1 || normalizedIndex > 26) return null;
    return {
      number: Math.ceil(normalizedIndex / 2),
      letter: normalizedIndex % 2 === 1 ? 'a' : 'b'
    };
  }

  function zoneLabel(number, letter) {
    return String(number) + normalizeZoneLetter(letter);
  }

  function buildZoneRange(startNumber, startLetter, endNumber, endLetter, hasExplicitEnd) {
    var a = parseInt(startNumber, 10);
    var b = parseInt(endNumber, 10);
    var startNormalizedLetter = normalizeZoneLetter(startLetter);
    var endNormalizedLetter = normalizeZoneLetter(endLetter);

    if (!hasExplicitEnd && startNormalizedLetter && !endNormalizedLetter) {
      endNormalizedLetter = startNormalizedLetter;
    }

    if (isNaN(a) || isNaN(b) || a < 1 || b < 1 || a > 13 || b > 13) return null;

    var minIndex = zoneIndex(a, startNormalizedLetter, false);
    var maxIndex = zoneIndex(b, endNormalizedLetter, true);
    if (minIndex === null || maxIndex === null) return null;

    if (minIndex > maxIndex) {
      var swapIndex = minIndex;
      minIndex = maxIndex;
      maxIndex = swapIndex;
    }

    var minParts = zonePartsFromIndex(minIndex);
    var maxParts = zonePartsFromIndex(maxIndex);
    if (!minParts || !maxParts) return null;

    var display;
    if (!hasExplicitEnd) {
      display = zoneLabel(a, startNormalizedLetter);
      if (!startNormalizedLetter) display = String(a);
    } else if (!startNormalizedLetter && !endNormalizedLetter) {
      display = minParts.number === maxParts.number
        ? String(minParts.number)
        : (minParts.number + '-' + maxParts.number);
    } else if (minIndex === maxIndex) {
      display = zoneLabel(minParts.number, minParts.letter);
    } else {
      display = zoneLabel(minParts.number, startNormalizedLetter || minParts.letter)
        + '-'
        + zoneLabel(maxParts.number, endNormalizedLetter || maxParts.letter);
    }

    return {
      min: minParts.number,
      max: maxParts.number,
      minIndex: minIndex,
      maxIndex: maxIndex,
      minLabel: zoneLabel(minParts.number, minParts.letter),
      maxLabel: zoneLabel(maxParts.number, maxParts.letter),
      display: display
    };
  }

  function parseStrictZoneInput(value) {
    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.parseStrictZoneInput === 'function') {
      var parsed = shared.parseStrictZoneInput(value);
      if (parsed) return parsed;
    }

    if (!value) return null;
    var source = String(value).trim().toLowerCase();
    source = source.replace(/^zones?\s*/i, '');
    source = source.replace(/\bthrough\b|\bthru\b|\bto\b/g, '-').replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, '');

    var match = source.match(/^(\d{1,2})([ab])?(?:-(\d{1,2})([ab])?)?$/);
    if (!match) return null;
    return buildZoneRange(match[1], match[2], match[3] || match[1], match[4], Boolean(match[3]));
  }

  function parseZoneRangeFromText(value) {
    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.parseZoneRangeFromText === 'function') {
      var sharedParsed = shared.parseZoneRangeFromText(value);
      if (sharedParsed) return sharedParsed;
    }

    if (!value) return null;
    var source = String(value).toLowerCase();
    source = source.replace(/[\u2013\u2014]/g, '-').replace(/\bthrough\b|\bthru\b|\bto\b/g, '-');

    var zoneChunk = source;
    var zoneSegment = source.match(/(?:usda\s*)?zones?[^.;\n\r]{0,120}/);
    if (zoneSegment) {
      zoneChunk = zoneSegment[0];
    } else if (String(value).trim().length > 48) {
      return null;
    }

    // Prefer two-digit zones (10-13) before [1-9], or "6-10" becomes "6-1".
    var rangeMatch = zoneChunk.match(/(1[0-3]|[1-9])\s*([ab])?\s*-\s*(1[0-3]|[1-9])\s*([ab])?/);
    if (rangeMatch) {
      return buildZoneRange(rangeMatch[1], rangeMatch[2], rangeMatch[3], rangeMatch[4], true);
    }

    var zoneMatch = zoneChunk.match(/\b(1[0-3]|[1-9])\s*([ab])?\b/);
    if (!zoneMatch) return null;
    return buildZoneRange(zoneMatch[1], zoneMatch[2], zoneMatch[1], zoneMatch[2], false);
  }

  function parseRange(value) {
    return parseStrictZoneInput(value) || parseZoneRangeFromText(value);
  }

  function rangeContainsIndex(range, index) {
    return !!range && index >= range.minIndex && index <= range.maxIndex;
  }

  function zoneToIndex(zone) {
    var normalized = String(zone || '').trim().toLowerCase();
    var match = normalized.match(/^([1-9]|1[0-3])([ab])$/);
    if (!match) return -1;
    return zoneIndex(match[1], match[2], false) || -1;
  }

  function getSavedZone() {
    var api = getZipApi();
    if (api && typeof api.getSavedZone === 'function') {
      return api.getSavedZone();
    }
    return null;
  }

  function readJsonRange(element, attributeName) {
    if (!element) return null;

    try {
      var raw = element.getAttribute(attributeName);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;

      if (typeof data.minIndex === 'number' && typeof data.maxIndex === 'number') {
        var minParts = zonePartsFromIndex(data.minIndex);
        var maxParts = zonePartsFromIndex(data.maxIndex);
        if (minParts && maxParts) {
          return {
            min: minParts.number,
            max: maxParts.number,
            minIndex: data.minIndex,
            maxIndex: data.maxIndex,
            minLabel: data.minLabel || zoneLabel(minParts.number, minParts.letter),
            maxLabel: data.maxLabel || zoneLabel(maxParts.number, maxParts.letter),
            display: data.display || (zoneLabel(minParts.number, minParts.letter) + '-' + zoneLabel(maxParts.number, maxParts.letter))
          };
        }
      }
    } catch (error) {}

    return null;
  }

  function getProductRange(root) {
    var modal = document.querySelector('[data-zone-map-modal]');
    var modalJsonRange = readJsonRange(modal, 'data-zone-map-product-range');
    if (modalJsonRange) return modalJsonRange;

    if (modal) {
      var modalSource = modal.getAttribute('data-zone-map-source') || modal.getAttribute('data-zone-map-display') || '';
      var parsedModalSource = parseRange(modalSource);
      if (parsedModalSource) return parsedModalSource;
    }

    var zoneChip = document.querySelector('[data-meta-zone]');
    if (zoneChip) {
      var chipRange = zoneChip.getAttribute('data-zone-range-display');
      var chipValue = zoneChip.querySelector('[data-meta-zone-value]');
      var parsedChip = parseRange(chipRange || (chipValue ? chipValue.textContent : ''));
      if (parsedChip) return parsedChip;
    }

    return parseRange(root.getAttribute('data-care-guide-default-zone-range'));
  }

  function getZoneGroup(userRange, productRange) {
    if (!userRange) return 'default';

    if (productRange && userRange.maxIndex < productRange.minIndex) {
      return 'colder-than-range';
    }

    if (productRange && userRange.minIndex > productRange.maxIndex) {
      return 'warmer-than-range';
    }

    if (userRange.max <= 5) return 'cold-edge';
    if (userRange.min >= 9) return 'heat-edge';
    if (userRange.min >= 8) return 'warm-edge';

    return 'core';
  }

  function getComboPanel(combo) {
    if (!combo) return null;

    var panel = combo.querySelector('[data-care-zone-panel]');
    if (panel) {
      combo.__careZonePanel = panel;
      panel.__careZoneCombo = combo;
      return panel;
    }

    if (combo.__careZonePanel && document.documentElement.contains(combo.__careZonePanel)) {
      return combo.__careZonePanel;
    }

    return null;
  }

  function getPortaledPanel(careGuide) {
    var combo = careGuide ? careGuide.querySelector('[data-care-zone-combo]') : null;
    var panel = combo ? getComboPanel(combo) : null;
    return panel && !careGuide.contains(panel) ? panel : null;
  }

  function queryCareGuideNodes(careGuide, selector) {
    var nodes = careGuide ? Array.prototype.slice.call(careGuide.querySelectorAll(selector)) : [];
    var panel = getPortaledPanel(careGuide);
    if (panel) {
      nodes = nodes.concat(Array.prototype.slice.call(panel.querySelectorAll(selector)));
    }
    return nodes;
  }

  function queryCareGuideNode(careGuide, selector) {
    var node = careGuide ? careGuide.querySelector(selector) : null;
    if (node) return node;
    var panel = getPortaledPanel(careGuide);
    return panel ? panel.querySelector(selector) : null;
  }

  function setText(root, selector, text) {
    var nodes = queryCareGuideNodes(root, selector);
    Array.prototype.forEach.call(nodes, function(node) {
      node.textContent = text;
    });
  }

  function getSavedHeatProfile() {
    var api = getZipApi();
    return api && typeof api.getSavedHeatProfile === 'function' ? api.getSavedHeatProfile() : null;
  }

  function copyMatchesGroup(node, group) {
    var value = node.getAttribute('data-care-zone-copy') || '';
    var groups = value.split(/[\s,|]+/).filter(Boolean);
    return groups.indexOf(group) !== -1;
  }

  function updateCopies(root, group) {
    var copyNodes = root.querySelectorAll('[data-care-zone-copy]');
    Array.prototype.forEach.call(copyNodes, function(node) {
      node.hidden = !copyMatchesGroup(node, group);
    });
  }

  function copyMatchesHeat(node, group) {
    var value = node.getAttribute('data-care-heat-copy') || '';
    var groups = value.split(/[\s,|]+/).filter(Boolean);
    return groups.indexOf(group) !== -1;
  }

  function updateHeatCopies(root, heatGroup) {
    var copyNodes = root.querySelectorAll('[data-care-heat-copy]');
    Array.prototype.forEach.call(copyNodes, function(node) {
      node.hidden = !copyMatchesHeat(node, heatGroup);
    });
  }

  function describeHeatState(userRange, heatProfile) {
    var isZoneTenPlus = userRange && userRange.min >= 10;

    if (!heatProfile) {
      return {
        group: 'unknown',
        current: 'Heat index appears after ZIP lookup.',
        summary: isZoneTenPlus
          ? 'USDA Zone ' + userRange.display + ' only measures winter low. Enter your ZIP code because summer heat index can make a humid Zone 10 much harder on plants than a lower-humidity coastal or western Zone 10.'
          : 'For Zones 10 and warmer, your ZIP code separates lower-humidity western heat from humid heat that can change how a listed zone performs.'
      };
    }

    return {
      group: heatProfile.level || 'unknown',
      current: heatProfile.zip
        ? ('ZIP ' + heatProfile.zip + ': ' + heatProfile.headline)
        : (heatProfile.label ? (heatProfile.label + ': ' + heatProfile.headline) : heatProfile.headline),
      summary: heatProfile.summary
    };
  }

  function ensureHeatSummaryNode(careGuide) {
    var zoneSummary = careGuide.querySelector('.zone-summary');
    if (!zoneSummary || queryCareGuideNode(careGuide, '[data-care-heat-summary]')) return;
    var host = zoneSummary.querySelector('[data-care-zone-combo]') || zoneSummary;

    var heatSummary = document.createElement('span');
    heatSummary.setAttribute('data-care-heat-summary', '');
    host.appendChild(heatSummary);
  }

  function updateHeatPanel(careGuide, userRange, heatState) {
    var panels = careGuide.querySelectorAll('.zone-panel[data-care-zone-copy]');
    var isZoneTenPlus = userRange && userRange.min >= 10;

    Array.prototype.forEach.call(panels, function(panel) {
      var value = panel.getAttribute('data-care-zone-copy') || '';
      if (!/(?:^|[\s,|])(heat-edge|warmer-than-range)(?:$|[\s,|])/.test(value)) return;

      var advisory = panel.querySelector('[data-care-heat-panel]');
      if (!advisory) {
        advisory = document.createElement('div');
        advisory.className = 'zone-note care-heat-advisory';
        advisory.setAttribute('data-care-heat-panel', '');
        panel.appendChild(advisory);
      }

      advisory.textContent = heatState.summary;
      advisory.hidden = !isZoneTenPlus && heatState.group === 'unknown';
    });
  }

  function describeState(group, userRange, productRange) {
    var productLabel = productRange ? ('This plant is listed for Zones ' + productRange.display + '.') : 'Care notes are optimized for your selected zone.';

    if (!userRange) {
      return {
        current: 'Enter your ZIP code',
        fit: productRange ? productLabel : 'General care guidance.',
        summary: 'Enter your ZIP code to set your USDA zone and tune watering, sun, soil, and winter notes to your climate.'
      };
    }

    var zoneLabelText = 'USDA Zone ' + userRange.display;

    if (group === 'colder-than-range') {
      return {
        current: zoneLabelText,
        fit: productLabel,
        summary: ZONE_GROUP_LABELS[group]
      };
    }

    if (group === 'warmer-than-range') {
      return {
        current: zoneLabelText,
        fit: productLabel,
        summary: ZONE_GROUP_LABELS[group]
      };
    }

    return {
      current: zoneLabelText,
      fit: productLabel,
      summary: ZONE_GROUP_LABELS[group] || ZONE_GROUP_LABELS.default
    };
  }

  function syncZoneDisplay(careGuide, userRange) {
    var displays = queryCareGuideNodes(careGuide, '[data-care-zone-display]');
    var text = userRange
      ? ('USDA Zone ' + userRange.display)
      : 'Enter your ZIP code to set your zone';

    Array.prototype.forEach.call(displays, function(node) {
      node.textContent = text;
    });
  }

  function syncZonePickerButtons(root) {
    var buttons = root.querySelectorAll('[data-care-zone-picker]');
    Array.prototype.forEach.call(buttons, function(button) {
      if (button.getAttribute('data-care-zone-picker-bound') === 'true') return;
      button.setAttribute('data-care-zone-picker-bound', 'true');

      button.addEventListener('click', function() {
        var candidates = document.querySelectorAll('[data-zone-trigger], #zone-trigger, [data-onboarding-target="zone-trigger"]');
        for (var i = 0; i < candidates.length; i += 1) {
          var candidate = candidates[i];
          if (!candidate || candidate.disabled || candidate.getAttribute('aria-disabled') === 'true') continue;
          var rect = candidate.getBoundingClientRect();
          if (rect.width === 0 && rect.height === 0) continue;
          candidate.click();
          return;
        }
      });
    });
  }

  function ensureRuntimeStyles() {
    if (document.getElementById('mrmaple-care-guide-zone-heat-styles')) return;

    var style = document.createElement('style');
    style.id = 'mrmaple-care-guide-zone-heat-styles';
    style.textContent = [
      '#mm-care-guide .zone-summary{margin:0;padding:0;border:0;border-radius:0;background:transparent;color:#2f3c2d;font-size:14px;line-height:1.45}',
      '#mm-care-guide .hero{overflow:visible}',
      '#mm-care-guide .care-zone-shell{position:relative;z-index:5}',
      '#mm-care-guide .care-zone-combo{position:relative;display:grid;gap:0;padding:12px 14px;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24));border-radius:16px;background:var(--zone-accent-soft,rgba(56,118,29,.08));box-shadow:0 10px 22px rgba(31,45,29,.08);z-index:8}',
      '#mm-care-guide .care-zone-combo__summary{position:relative;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:4px 12px;align-items:center;min-height:44px;cursor:pointer;list-style:none}',
      '#mm-care-guide .care-zone-combo__summary::-webkit-details-marker{display:none}',
      '#mm-care-guide .care-zone-combo__summary::marker{content:""}',
      '#mm-care-guide .care-zone-combo:not([open]) .care-zone-combo__panel{display:none}',
      '#mm-care-guide .care-zone-combo[open]{z-index:60}',
      '#mm-care-guide .care-zone-combo__panel{position:absolute;top:calc(100% + 10px);right:0;width:min(860px,calc(100vw - 32px));max-width:calc(100vw - 32px);max-height:min(72vh,720px);display:grid;grid-template-columns:minmax(300px,.95fr) minmax(260px,1fr);gap:14px;align-items:start;padding:14px;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24));border-radius:18px;background:#fff;box-shadow:0 22px 48px rgba(31,45,29,.22);box-sizing:border-box;overflow:auto;text-align:left}',
      '#mm-care-guide .care-zone-combo__panel-header{grid-column:1/-1;display:flex;align-items:flex-start;justify-content:space-between;gap:12px}',
      '#mm-care-guide .care-zone-combo__panel-title{margin:0;color:var(--zone-accent,#38761d);font-size:clamp(24px,2.35vw,32px);font-weight:900;line-height:1.08}',
      '#mm-care-guide .care-zone-combo__close{width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24));border-radius:999px;background:#f7fbf4;color:var(--zone-accent,#38761d);cursor:pointer;font-family:Arial,sans-serif;font-size:24px;font-weight:700;line-height:0}',
      '#mm-care-guide .care-zone-combo__content{display:grid;gap:10px;align-content:start}',
      '#mm-care-guide .care-zone-map{display:grid;grid-template-rows:auto auto;align-content:start;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24));border-radius:16px;background:#eef3ee;overflow:hidden}',
      '#mm-care-guide .care-zone-map__canvas{width:100%;min-height:0;aspect-ratio:1200/760;max-height:min(46vh,420px);display:grid;place-items:center;background:#eef3ee;overflow:hidden}',
      '#mm-care-guide .care-zone-map__svg,#mm-care-guide .care-zone-map__fallback{width:100%!important;height:100%!important;min-height:0;display:block;flex:1 1 auto!important;border-radius:0!important;background:transparent!important;object-fit:contain}',
      '#mm-care-guide .care-zone-map__svg{transform:scale(1.45);transform-origin:center center}',
      '#mm-care-guide .care-zone-map[data-care-zone-map-focused="true"] .care-zone-map__svg{transform:none}',
      '#mm-care-guide .care-zone-map__fallback-text{padding:18px;color:#4f5f4d;font-size:13px;font-weight:800;text-align:center}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone{fill:var(--zone-color,#d9dfd8);stroke:rgba(34,54,35,.2);stroke-width:.8;vector-effect:non-scaling-stroke;opacity:.95;paint-order:stroke fill markers;stroke-linejoin:round}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone[data-zone-variant="a"]{opacity:.86}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone.is-in-range{fill:#6f9f46;stroke:rgba(36,78,18,.68);stroke-width:1.15;opacity:1}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone.is-user-zone{fill:#4f62a8;stroke:rgba(25,39,103,.88);stroke-width:1.6;opacity:1}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone.is-in-range.is-user-zone{fill:#3f5298;stroke:rgba(18,32,88,.92);stroke-width:1.85}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__zone.is-dimmed{opacity:.3}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__state{stroke:rgba(35,48,35,.52);stroke-width:1.1;vector-effect:non-scaling-stroke;pointer-events:none}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__state-label{fill:rgba(25,37,25,.78);stroke:rgba(255,255,255,.86);stroke-width:4;paint-order:stroke fill;font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-size:22px;font-weight:850;letter-spacing:0;text-anchor:middle;dominant-baseline:central;pointer-events:none;user-select:none}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__state-label--small{font-size:17px;stroke-width:3.5}',
      '#mm-care-guide .care-zone-map__pin{pointer-events:none}',
      '#mm-care-guide .care-zone-map__pin-body{transform-box:fill-box;transform-origin:center bottom;filter:drop-shadow(0 7px 8px rgba(31,45,29,.28));animation:care-zone-pin-drop .62s cubic-bezier(.19,1,.22,1) both}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__marker-pulse{fill:rgba(86,122,47,.22)}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__marker-ring{fill:#fff;stroke:#4f7f2c;stroke-width:5}',
      '#mm-care-guide .care-zone-map__svg .usda-zone-map__marker-core{fill:#4f7f2c;stroke:#fff;stroke-width:2}',
      '#mm-care-guide .care-zone-map__label{margin:0;padding:8px 10px;border-top:1px solid rgba(56,118,29,.24);background:rgba(255,255,255,.88);color:#20321f;font-size:12px;font-weight:900;line-height:1.25}',
      '@keyframes care-zone-pin-drop{0%{opacity:0;transform:translateY(-32px) scale(.72)}62%{opacity:1;transform:translateY(4px) scale(1.08)}100%{opacity:1;transform:translateY(0) scale(1)}}',
      '#mm-care-guide .care-zone-combo__summary:after{content:"";position:absolute;top:50%;right:2px;width:9px;height:9px;border-right:2px solid var(--zone-accent,#38761d);border-bottom:2px solid var(--zone-accent,#38761d);transform:translateY(-50%) rotate(45deg);transition:transform .18s ease}',
      '#mm-care-guide .care-zone-combo[open] .care-zone-combo__summary:after{transform:translateY(-50%) rotate(225deg)}',
      '#mm-care-guide .care-zone-combo__label{grid-column:1;color:var(--zone-accent,#38761d);font-size:12px;font-weight:900;line-height:1.1}',
      '#mm-care-guide .care-zone-combo__primary,#mm-care-guide .care-zone-combo__meta{grid-column:1;min-width:0}',
      '#mm-care-guide .care-zone-combo__primary{color:var(--zone-accent,#38761d);font-size:clamp(17px,1.45vw,21px);font-weight:900;line-height:1.15}',
      '#mm-care-guide .care-zone-combo__meta{color:#485546;font-size:clamp(13px,1.05vw,15px);font-weight:750;line-height:1.3}',
      '#mm-care-guide .care-zip-control{display:grid;gap:8px;padding:10px 12px;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24));border-radius:14px;background:#fff;color:var(--ink,#1f2d1d);box-shadow:0 8px 18px rgba(31,45,29,.06)}',
      '#mm-care-guide .care-zip-control--embedded{gap:6px;margin:0;padding:0;border:0;border-radius:0;background:transparent;box-shadow:none}',
      '#mm-care-guide .care-zip-control__label{color:var(--zone-accent,#38761d);font-size:12px;font-weight:900;letter-spacing:0}',
      '#mm-care-guide .care-zip-control__row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px;align-items:center}',
      '#mm-care-guide .care-zip-input{min-width:0;min-height:34px;border:1px solid rgba(56,118,29,.42);border-radius:999px;padding:7px 12px;font:inherit;font-size:14px;line-height:1.2;color:#132013;box-shadow:0 0 0 1px rgba(56,118,29,.1)}',
      '#mm-care-guide .care-zip-button{min-height:34px;border:1px solid var(--zone-accent,#38761d);border-radius:999px;background:var(--zone-accent,#38761d);color:#fff;cursor:pointer;font:inherit;font-size:13px;font-weight:900;line-height:1.1;padding:7px 12px;white-space:nowrap}',
      '#mm-care-guide .care-zip-button[disabled]{cursor:wait;opacity:.72}',
      '#mm-care-guide .care-zip-status{margin:0!important;color:#4f5f4d;font-size:12px!important;line-height:1.35!important;text-align:left!important}',
      '#mm-care-guide .care-zip-status[data-care-zip-state="error"]{color:#9a3412}',
      '#mm-care-guide .zone-summary [data-care-zone-fit]{color:var(--ink,#1f2d1d);font-weight:800}',
      '#mm-care-guide .zone-summary [data-care-zone-summary]{color:#485546}',
      '#mm-care-guide .zone-summary [data-care-heat-summary]{color:#5f4525;font-size:13px;line-height:1.4}',
      '#mm-care-guide .care-heat-advisory{font-weight:700}',
      '@media(max-width:680px){#mm-care-guide .care-zone-combo__summary{min-height:48px}#mm-care-guide .care-zone-combo__panel{position:fixed;inset:0;width:auto;max-width:none;max-height:none;grid-template-columns:1fr;align-content:start;padding:18px 14px 24px;border:0;border-radius:0;z-index:2147483000;overflow:auto}#mm-care-guide .care-zone-map{min-height:0}#mm-care-guide .care-zone-map__canvas{max-height:42vh}#mm-care-guide .care-zone-map__svg{transform:scale(1.35)}#mm-care-guide .care-zip-control__row{grid-template-columns:1fr}#mm-care-guide .care-zip-status{text-align:center!important}}',
      'body.care-zone-panel-open{overflow:hidden}',
      '.care-zone-combo__panel--portaled{position:fixed!important;inset:0!important;width:auto!important;max-height:none!important;display:grid!important;grid-template-columns:1fr!important;align-content:start!important;gap:14px!important;padding:calc(env(safe-area-inset-top,0px) + 18px) 14px calc(env(safe-area-inset-bottom,0px) + 24px)!important;border:0!important;border-radius:0!important;background:#fff!important;box-shadow:none!important;overflow:auto!important;text-align:left!important;z-index:2147483647!important;box-sizing:border-box!important}',
      '.care-zone-combo__panel--portaled[hidden]{display:none!important}',
      '.care-zone-combo__panel--portaled .care-zone-combo__panel-header{display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:12px!important}',
      '.care-zone-combo__panel--portaled .care-zone-combo__panel-title{margin:0!important;color:var(--zone-accent,#38761d)!important;font-size:clamp(26px,7vw,34px)!important;font-weight:900!important;line-height:1.08!important}',
      '.care-zone-combo__panel--portaled .care-zone-combo__close{width:44px!important;height:44px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:0!important;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24))!important;border-radius:999px!important;background:#f7fbf4!important;color:var(--zone-accent,#38761d)!important;cursor:pointer!important;font-family:Arial,sans-serif!important;font-size:28px!important;font-weight:700!important;line-height:0!important;flex:0 0 auto!important}',
      '.care-zone-combo__panel--portaled .care-zone-map{min-height:0!important;display:grid!important;grid-template-rows:auto auto!important;align-content:start!important;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24))!important;border-radius:16px!important;background:#eef3ee!important;overflow:hidden!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__canvas{width:100%!important;min-height:0!important;aspect-ratio:1200/760!important;max-height:42vh!important;display:grid!important;place-items:center!important;background:#eef3ee!important;overflow:hidden!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg,.care-zone-combo__panel--portaled .care-zone-map__fallback{width:100%!important;height:100%!important;min-height:0!important;display:block!important;border-radius:0!important;background:transparent!important;object-fit:contain!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg{transform:scale(1.35)!important;transform-origin:center center!important}',
      '.care-zone-combo__panel--portaled .care-zone-map[data-care-zone-map-focused="true"] .care-zone-map__svg{transform:none!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__fallback-text{padding:18px!important;color:#4f5f4d!important;font-size:13px!important;font-weight:800!important;text-align:center!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone{fill:var(--zone-color,#d9dfd8)!important;stroke:rgba(34,54,35,.2)!important;stroke-width:.8!important;vector-effect:non-scaling-stroke!important;opacity:.95!important;paint-order:stroke fill markers!important;stroke-linejoin:round!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone[data-zone-variant="a"]{opacity:.86!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone.is-in-range{fill:#6f9f46!important;stroke:rgba(36,78,18,.68)!important;stroke-width:1.15!important;opacity:1!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone.is-user-zone{fill:#4f62a8!important;stroke:rgba(25,39,103,.88)!important;stroke-width:1.6!important;opacity:1!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone.is-in-range.is-user-zone{fill:#3f5298!important;stroke:rgba(18,32,88,.92)!important;stroke-width:1.85!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__zone.is-dimmed{opacity:.3!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__state{stroke:rgba(35,48,35,.52)!important;stroke-width:1.1!important;vector-effect:non-scaling-stroke!important;pointer-events:none!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__state-label{fill:rgba(25,37,25,.78)!important;stroke:rgba(255,255,255,.86)!important;stroke-width:4!important;paint-order:stroke fill!important;font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;font-size:22px!important;font-weight:850!important;letter-spacing:0!important;text-anchor:middle!important;dominant-baseline:central!important;pointer-events:none!important;user-select:none!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__state-label--small{font-size:17px!important;stroke-width:3.5!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__pin{pointer-events:none!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__pin-body{transform-box:fill-box!important;transform-origin:center bottom!important;filter:drop-shadow(0 7px 8px rgba(31,45,29,.28))!important;animation:care-zone-pin-drop .62s cubic-bezier(.19,1,.22,1) both!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__marker-pulse{fill:rgba(86,122,47,.22)!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__marker-ring{fill:#fff!important;stroke:#4f7f2c!important;stroke-width:5!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__svg .usda-zone-map__marker-core{fill:#4f7f2c!important;stroke:#fff!important;stroke-width:2!important}',
      '.care-zone-combo__panel--portaled .care-zone-map__label{margin:0!important;padding:8px 10px!important;border-top:1px solid rgba(56,118,29,.24)!important;background:rgba(255,255,255,.88)!important;color:#20321f!important;font-size:12px!important;font-weight:900!important;line-height:1.25!important}',
      '.care-zone-combo__panel--portaled .care-zone-combo__content{display:grid!important;gap:14px!important;align-content:start!important}',
      '.care-zone-combo__panel--portaled .care-zip-control{display:grid!important;gap:8px!important;padding:10px 12px!important;border:1px solid var(--zone-accent-border,rgba(56,118,29,.24))!important;border-radius:14px!important;background:#fff!important;color:var(--ink,#1f2d1d)!important;box-shadow:0 8px 18px rgba(31,45,29,.06)!important}',
      '.care-zone-combo__panel--portaled .care-zip-control--embedded{gap:8px!important;margin:0!important}',
      '.care-zone-combo__panel--portaled .care-zip-control__row{display:grid!important;grid-template-columns:1fr!important;gap:8px!important;align-items:center!important}',
      '.care-zone-combo__panel--portaled .care-zip-input{min-width:0!important;min-height:44px!important;border:1px solid rgba(56,118,29,.42)!important;border-radius:999px!important;padding:9px 14px!important;font:inherit!important;font-size:16px!important;line-height:1.2!important;color:#132013!important;box-shadow:0 0 0 1px rgba(56,118,29,.1)!important}',
      '.care-zone-combo__panel--portaled .care-zip-button{min-height:46px!important;border:1px solid var(--zone-accent,#38761d)!important;border-radius:999px!important;background:var(--zone-accent,#38761d)!important;color:#fff!important;cursor:pointer!important;font:inherit!important;font-size:15px!important;font-weight:900!important;line-height:1.1!important;padding:9px 14px!important;white-space:nowrap!important}',
      '.care-zone-combo__panel--portaled .care-zip-status{margin:0!important;color:#4f5f4d!important;font-size:12px!important;line-height:1.35!important;text-align:center!important}',
      '.care-zone-combo__panel--portaled [data-care-zone-fit]{color:var(--ink,#1f2d1d)!important;font-weight:800!important;font-size:18px!important;line-height:1.35!important}',
      '.care-zone-combo__panel--portaled [data-care-zone-summary]{color:#485546!important;font-size:16px!important;line-height:1.5!important}',
      '.care-zone-combo__panel--portaled [data-care-heat-summary]{color:#5f4525!important;font-size:14px!important;line-height:1.45!important}'
    ].join('');
    document.head.appendChild(style);
  }

  function setZipStatus(status, message, state) {
    if (!status) return;
    status.textContent = message || '';
    if (state) {
      status.setAttribute('data-care-zip-state', state);
    } else {
      status.removeAttribute('data-care-zip-state');
    }
  }

  function createZipLookupControl(careGuide) {
    var form = document.createElement('form');
    form.className = 'care-zip-control care-zip-control--embedded';
    form.setAttribute('data-care-zip-lookup', '');

    var inputId = (careGuide.id || 'mm-care-guide') + '-zip-input';

    var row = document.createElement('div');
    row.className = 'care-zip-control__row';

    var input = document.createElement('input');
    input.className = 'care-zip-input';
    input.id = inputId;
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'postal-code';
    input.maxLength = 10;
    input.placeholder = 'ZIP code';
    input.setAttribute('aria-label', 'Your ZIP code');
    input.setAttribute('data-care-zip-input', '');

    var button = document.createElement('button');
    button.className = 'care-zip-button';
    button.type = 'submit';
    button.setAttribute('data-care-zip-submit', '');
    button.textContent = 'Update';

    var status = document.createElement('p');
    status.className = 'care-zip-status';
    status.setAttribute('data-care-zip-status', '');
    status.setAttribute('aria-live', 'polite');

    row.appendChild(input);
    row.appendChild(button);
    form.appendChild(row);
    form.appendChild(status);

    return form;
  }

  function ensureComboPanel(combo) {
    if (!combo) return null;

    var summary = combo.querySelector('summary');
    var panel = getComboPanel(combo);

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'care-zone-combo__panel';
      panel.setAttribute('data-care-zone-panel', '');
      if (summary && summary.nextSibling) {
        combo.insertBefore(panel, summary.nextSibling);
      } else {
        combo.appendChild(panel);
      }
    }

    combo.__careZonePanel = panel;
    panel.__careZoneCombo = combo;
    panel.classList.add('care-zone-combo__panel');

    var header = panel.querySelector('.care-zone-combo__panel-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'care-zone-combo__panel-header';

      var title = document.createElement('p');
      title.className = 'care-zone-combo__panel-title';
      title.textContent = 'Your growing zone';

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'care-zone-combo__close';
      close.setAttribute('data-care-zone-close', '');
      close.setAttribute('aria-label', 'Close zone details');
      close.textContent = '×';

      header.appendChild(title);
      header.appendChild(close);
      panel.insertBefore(header, panel.firstChild);
    }

    var map = ensureZoneMapPreview(panel);
    var content = panel.querySelector('[data-care-zone-panel-content]');
    if (!content) {
      content = document.createElement('div');
      content.className = 'care-zone-combo__content';
      content.setAttribute('data-care-zone-panel-content', '');
      panel.appendChild(content);
    }

    if (map && map.parentNode !== panel) {
      panel.insertBefore(map, content);
    }

    Array.prototype.slice.call(combo.children).forEach(function(child) {
      if (child === summary || child === panel) return;
      content.appendChild(child);
    });

    bindComboClose(combo);
    bindPanelClose(combo, panel);
    syncComboPanelPortal(combo);
    return panel;
  }

  function createZoneMapPreview() {
    var map = document.createElement('div');
    map.className = 'care-zone-map';
    map.setAttribute('data-care-zone-map', '');
    normalizeZoneMapPreview(map);
    return map;
  }

  function ensureZoneMapPreview(panel) {
    if (!panel) return null;
    var map = panel.querySelector('[data-care-zone-map]');
    if (!map) {
      map = createZoneMapPreview();
    }
    normalizeZoneMapPreview(map);
    return map;
  }

  function deriveSiblingAssetUrl(assetName) {
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i].getAttribute('src') || '';
      if (src.indexOf('mm-care-guide-zone.js') === -1) continue;
      var cleanSrc = src.split('?')[0];
      if (/mm-care-guide-zone\.js$/.test(cleanSrc)) {
        return cleanSrc.replace(/mm-care-guide-zone\.js$/, assetName);
      }
    }
    return '';
  }

  function getCareZoneMapSvgUrl(map) {
    var existing = map ? map.getAttribute('data-care-zone-map-svg-url') : '';
    if (existing) return existing;

    var config = window.MrMapleZoneMapConfig || {};
    if (config.svgAssetUrl) return config.svgAssetUrl;

    var sharedHost = document.querySelector('[data-zone-map-svg-url]');
    if (sharedHost) {
      var sharedUrl = sharedHost.getAttribute('data-zone-map-svg-url');
      if (sharedUrl) return sharedUrl;
    }

    return deriveSiblingAssetUrl('usda-zone-map-conus.svg');
  }

  function getCareZoneMapImageUrl() {
    var config = window.MrMapleZoneMapConfig || {};
    return config.mapImageUrl || '';
  }

  function normalizeZoneMapPreview(map) {
    if (!map) return null;
    map.classList.add('care-zone-map');
    map.setAttribute('data-care-zone-map', '');

    var svgUrl = getCareZoneMapSvgUrl(map);
    if (svgUrl) {
      map.setAttribute('data-care-zone-map-svg-url', svgUrl);
    }

    var canvas = map.querySelector('[data-care-zone-map-canvas]');
    if (!canvas) {
      map.innerHTML = '';
      canvas = document.createElement('div');
      canvas.className = 'care-zone-map__canvas';
      canvas.setAttribute('data-care-zone-map-canvas', '');
      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', 'USDA hardiness zone map');
      canvas.textContent = 'Loading USDA hardiness zone map...';
      map.appendChild(canvas);
    }

    var label = map.querySelector('[data-care-zone-map-label]');
    if (!label) {
      label = document.createElement('p');
      label.className = 'care-zone-map__label';
      label.setAttribute('data-care-zone-map-label', '');
      label.textContent = 'Enter ZIP for map pin';
      map.appendChild(label);
    }

    return map;
  }

  function fetchCareZoneMapSvg(svgUrl) {
    if (!svgUrl) return Promise.reject(new Error('Missing USDA hardiness zone SVG URL'));
    if (careMapCache.markupByUrl[svgUrl]) return Promise.resolve(careMapCache.markupByUrl[svgUrl]);
    if (careMapCache.promiseByUrl[svgUrl]) return careMapCache.promiseByUrl[svgUrl];

    careMapCache.promiseByUrl[svgUrl] = fetch(svgUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load USDA hardiness zone SVG');
        return response.text();
      })
      .then(function(svgText) {
        var markup = svgText.replace(/<\?xml[\s\S]*?\?>\s*/i, '').trim();
        careMapCache.markupByUrl[svgUrl] = markup;
        return markup;
      })
      .finally(function() {
        careMapCache.promiseByUrl[svgUrl] = null;
      });

    return careMapCache.promiseByUrl[svgUrl];
  }

  function renderCareZoneMapFallback(map) {
    var canvas = map ? map.querySelector('[data-care-zone-map-canvas]') : null;
    if (!canvas) return;

    var imageUrl = getCareZoneMapImageUrl();
    canvas.innerHTML = '';
    if (imageUrl) {
      var image = document.createElement('img');
      image.className = 'care-zone-map__fallback';
      image.src = imageUrl;
      image.alt = 'USDA hardiness zone map';
      image.loading = 'lazy';
      canvas.appendChild(image);
      return;
    }

    var message = document.createElement('span');
    message.className = 'care-zone-map__fallback-text';
    message.textContent = 'USDA hardiness zone map unavailable.';
    canvas.appendChild(message);
  }

  function uniquifyCareMapSvgIds(svg, map) {
    if (!svg || !map) return;

    var suffix = map.getAttribute('data-care-zone-map-instance');
    if (!suffix) {
      suffix = 'care-zone-map-' + nextCareMapInstanceId;
      nextCareMapInstanceId += 1;
      map.setAttribute('data-care-zone-map-instance', suffix);
    }

    var title = svg.querySelector('#usda-zone-map-title');
    var desc = svg.querySelector('#usda-zone-map-desc');
    if (title && desc) {
      title.id = suffix + '-title';
      desc.id = suffix + '-desc';
      svg.setAttribute('aria-labelledby', title.id + ' ' + desc.id);
    }

    var markerIcon = svg.querySelector('#usda-you-are-here-icon');
    if (markerIcon) {
      markerIcon.id = suffix + '-you-are-here-icon';
    }
  }

  function loadCareZoneMapPreview(map) {
    normalizeZoneMapPreview(map);
    if (!map) return Promise.resolve(null);

    var state = map.__careZoneMapState || {};
    if (state.promise) return state.promise;
    if (state.svg) return Promise.resolve(state);

    var svgUrl = getCareZoneMapSvgUrl(map);
    if (!svgUrl) {
      map.setAttribute('data-care-zone-map-state', 'fallback');
      renderCareZoneMapFallback(map);
      return Promise.resolve(state);
    }

    map.setAttribute('data-care-zone-map-state', 'loading');
    map.setAttribute('aria-busy', 'true');

    state.promise = fetchCareZoneMapSvg(svgUrl)
      .then(function(markup) {
        var canvas = map.querySelector('[data-care-zone-map-canvas]');
        if (!canvas) throw new Error('Missing care zone map canvas');
        canvas.innerHTML = '';
        canvas.insertAdjacentHTML('afterbegin', markup);

        var svg = canvas.querySelector('[data-zone-map-svg]');
        if (!svg) throw new Error('Missing USDA hardiness zone SVG');

        svg.classList.add('care-zone-map__svg');
        uniquifyCareMapSvgIds(svg, map);

        state.svg = svg;
        state.baseViewBox = parseSvgViewBox(svg);
        state.zonePaths = Array.prototype.slice.call(svg.querySelectorAll('[data-zone]'));
        map.__careZoneMapState = state;
        map.setAttribute('data-care-zone-map-state', 'ready');
        map.removeAttribute('aria-busy');
        return state;
      })
      .catch(function() {
        state.promise = null;
        state.svg = null;
        state.zonePaths = [];
        map.__careZoneMapState = state;
        map.setAttribute('data-care-zone-map-state', 'fallback');
        map.removeAttribute('aria-busy');
        renderCareZoneMapFallback(map);
        return state;
      });

    map.__careZoneMapState = state;
    return state.promise;
  }

  function getProjectionValue(svg, name) {
    if (!svg) return NaN;
    return parseFloat(svg.getAttribute(name) || 'NaN');
  }

  function clampNumber(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function cloneViewBox(box) {
    if (!box) return null;
    return {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height
    };
  }

  function parseSvgViewBox(svg) {
    if (!svg) return null;

    var raw = svg.getAttribute('viewBox') || '';
    var parts = raw.trim().split(/[\s,]+/).map(function(part) {
      return parseFloat(part);
    });

    if (parts.length === 4 && parts.every(function(part) { return isFinite(part); }) && parts[2] > 0 && parts[3] > 0) {
      return {
        x: parts[0],
        y: parts[1],
        width: parts[2],
        height: parts[3]
      };
    }

    if (svg.viewBox && svg.viewBox.baseVal && svg.viewBox.baseVal.width > 0 && svg.viewBox.baseVal.height > 0) {
      return {
        x: svg.viewBox.baseVal.x,
        y: svg.viewBox.baseVal.y,
        width: svg.viewBox.baseVal.width,
        height: svg.viewBox.baseVal.height
      };
    }

    return null;
  }

  function formatViewBoxNumber(value) {
    return String(Math.round(value * 1000) / 1000);
  }

  function setSvgViewBox(svg, box) {
    if (!svg || !box) return;
    svg.setAttribute(
      'viewBox',
      [
        formatViewBoxNumber(box.x),
        formatViewBoxNumber(box.y),
        formatViewBoxNumber(box.width),
        formatViewBoxNumber(box.height)
      ].join(' ')
    );
  }

  function clampViewBoxToBase(box, baseBox) {
    if (!box || !baseBox) return null;

    var width = clampNumber(box.width, 1, baseBox.width);
    var height = clampNumber(box.height, 1, baseBox.height);
    var maxX = baseBox.x + baseBox.width - width;
    var maxY = baseBox.y + baseBox.height - height;

    return {
      x: clampNumber(box.x, baseBox.x, maxX),
      y: clampNumber(box.y, baseBox.y, maxY),
      width: width,
      height: height
    };
  }

  function resetCareZoneMapView(map, svg, state) {
    if (!map || !svg) return;
    var baseBox = state && state.baseViewBox ? state.baseViewBox : parseSvgViewBox(svg);
    if (baseBox) {
      setSvgViewBox(svg, baseBox);
      if (state) state.baseViewBox = cloneViewBox(baseBox);
    }
    map.removeAttribute('data-care-zone-map-focused');
  }

  function focusCareZoneMapOnPoint(map, svg, state, point) {
    if (!map || !svg || !point) return;

    var baseBox = state && state.baseViewBox ? state.baseViewBox : parseSvgViewBox(svg);
    if (!baseBox) return;

    if (state && !state.baseViewBox) {
      state.baseViewBox = cloneViewBox(baseBox);
    }

    var width = baseBox.width / CARE_ZONE_MAP_FOCUS_ZOOM;
    var height = baseBox.height / CARE_ZONE_MAP_FOCUS_ZOOM;
    var focusedBox = clampViewBoxToBase(
      {
        x: point.x - (width / 2),
        y: point.y - (height / 2),
        width: width,
        height: height
      },
      baseBox
    );

    if (!focusedBox) return;
    setSvgViewBox(svg, focusedBox);
    map.setAttribute('data-care-zone-map-focused', 'true');
  }

  function projectLonLatToSvg(svg, longitude, latitude) {
    if (!svg || !isFinite(longitude) || !isFinite(latitude)) return null;

    var phi1 = 29.5 * (Math.PI / 180);
    var phi2 = 45.5 * (Math.PI / 180);
    var phi0 = 23 * (Math.PI / 180);
    var lambda0 = -96 * (Math.PI / 180);

    var n = 0.5 * (Math.sin(phi1) + Math.sin(phi2));
    var c = (Math.cos(phi1) * Math.cos(phi1)) + (2 * n * Math.sin(phi1));
    var rho0 = Math.sqrt(c - (2 * n * Math.sin(phi0))) / n;

    var lam = longitude * (Math.PI / 180);
    var phi = latitude * (Math.PI / 180);
    var theta = n * (lam - lambda0);
    var rho = Math.sqrt(Math.max(0, c - (2 * n * Math.sin(phi)))) / n;
    var projectedX = rho * Math.sin(theta);
    var projectedY = rho0 - (rho * Math.cos(theta));

    var minX = getProjectionValue(svg, 'data-proj-min-x');
    var maxY = getProjectionValue(svg, 'data-proj-max-y');
    var scale = getProjectionValue(svg, 'data-proj-scale');
    var pad = getProjectionValue(svg, 'data-proj-pad');

    if (!isFinite(minX) || !isFinite(maxY) || !isFinite(scale) || !isFinite(pad)) {
      return null;
    }

    return {
      x: ((projectedX - minX) * scale) + pad,
      y: ((maxY - projectedY) * scale) + pad
    };
  }

  function getCareZoneMarkerIconId(svg, map) {
    var suffix = map ? map.getAttribute('data-care-zone-map-instance') : '';
    if (suffix) return suffix + '-you-are-here-icon';

    var icon = svg ? svg.querySelector('[id$="-you-are-here-icon"]') : null;
    if (icon && icon.id) return icon.id;

    return 'usda-you-are-here-icon';
  }

  function ensureCareZoneMapMarker(svg, map) {
    if (!svg) return null;

    var marker = svg.querySelector('[data-care-zone-pin]');
    if (marker && !marker.querySelector('[data-care-zone-pin-body]')) {
      marker.remove();
      marker = null;
    }
    if (marker) return marker;

    var markerLayer = svg.querySelector('[data-zone-map-marker-layer]');
    if (!markerLayer) {
      markerLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      markerLayer.setAttribute('data-zone-map-marker-layer', '');
      svg.appendChild(markerLayer);
    }

    marker = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    marker.setAttribute('class', 'care-zone-map__pin');
    marker.setAttribute('data-care-zone-pin', '');
    marker.setAttribute('role', 'img');
    marker.setAttribute('aria-label', 'Saved ZIP location');
    marker.setAttribute('display', 'none');

    var body = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    body.setAttribute('class', 'care-zone-map__pin-body');
    body.setAttribute('data-care-zone-pin-body', '');

    var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    var iconId = getCareZoneMarkerIconId(svg, map);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + iconId);
    use.setAttribute('href', '#' + iconId);
    body.appendChild(use);
    marker.appendChild(body);

    markerLayer.appendChild(marker);
    return marker;
  }

  function resolveHeatMapCoordinates(heatProfile) {
    var lat = parseFloat(heatProfile && heatProfile.latitude);
    var lon = parseFloat(heatProfile && heatProfile.longitude);
    if (isFinite(lat) && isFinite(lon)) {
      return Promise.resolve({ latitude: lat, longitude: lon });
    }

    var zip = heatProfile && heatProfile.zip;
    var api = getZipApi();
    if (!zip || !api || typeof api.lookupLocationFromZip !== 'function') {
      return Promise.resolve(null);
    }

    return api.lookupLocationFromZip(zip)
      .then(function(location) {
        if (!location || !isFinite(location.latitude) || !isFinite(location.longitude)) {
          return null;
        }

        return {
          latitude: location.latitude,
          longitude: location.longitude
        };
      })
      .catch(function() {
        return null;
      });
  }

  function maybePersistHeatMapCoordinates(heatProfile, coordinates) {
    if (!heatProfile || !coordinates) return;
    if (!isFinite(coordinates.latitude) || !isFinite(coordinates.longitude)) return;
    if (isFinite(parseFloat(heatProfile.latitude)) && isFinite(parseFloat(heatProfile.longitude))) return;

    var api = getZipApi();
    if (!api || typeof api.persistHeatProfile !== 'function') return;

    api.persistHeatProfile(Object.assign({}, heatProfile, {
      latitude: coordinates.latitude,
      longitude: coordinates.longitude
    }));
  }

  function applyCareZoneMapState(map, heatProfile, userRange, productRange, coordinates) {
    if (!map) return;

    var state = map.__careZoneMapState || {};
    var svg = state.svg || map.querySelector('[data-zone-map-svg]');
    var label = map.querySelector('[data-care-zone-map-label]');

    if (label) {
      label.textContent = heatProfile && heatProfile.zip
        ? ('ZIP ' + heatProfile.zip + (heatProfile.label ? ' - ' + heatProfile.label.replace(/^ZIP\s+\d{5}\s*/i, '') : ''))
        : 'Enter ZIP for map pin';
    }

    if (!svg) return;

    var paths = state.zonePaths && state.zonePaths.length
      ? state.zonePaths
      : Array.prototype.slice.call(svg.querySelectorAll('[data-zone]'));

    paths.forEach(function(path) {
      var zoneValue = path.getAttribute('data-zone') || '';
      var index = zoneToIndex(zoneValue);
      var inRange = rangeContainsIndex(productRange, index);
      var isUserZone = rangeContainsIndex(userRange, index);

      path.classList.toggle('is-in-range', inRange);
      path.classList.toggle('is-user-zone', isUserZone);
      path.classList.toggle('is-dimmed', Boolean(productRange) && !inRange && !isUserZone);
    });

    var marker = ensureCareZoneMapMarker(svg, map);
    var lat = parseFloat(coordinates && coordinates.latitude);
    var lon = parseFloat(coordinates && coordinates.longitude);
    if (!isFinite(lat) || !isFinite(lon)) {
      lat = parseFloat(heatProfile && heatProfile.latitude);
      lon = parseFloat(heatProfile && heatProfile.longitude);
    }
    var point = projectLonLatToSvg(svg, lon, lat);

    if (!marker || !point) {
      if (marker) marker.setAttribute('display', 'none');
      resetCareZoneMapView(map, svg, state);
      return;
    }

    focusCareZoneMapOnPoint(map, svg, state, point);
    marker.removeAttribute('display');
    marker.setAttribute('transform', 'translate(' + Math.round(point.x) + ' ' + Math.round(point.y) + ')');

    var pinBody = marker.querySelector('[data-care-zone-pin-body]');
    if (pinBody) {
      pinBody.style.animation = 'none';
      pinBody.getBoundingClientRect();
      pinBody.style.animation = '';
    }
  }

  function syncZoneMapPreview(careGuide, heatProfile, userRange, productRange) {
    var combo = careGuide.querySelector('[data-care-zone-combo]');
    var panel = combo ? ensureComboPanel(combo) : null;
    var map = panel ? ensureZoneMapPreview(panel) : null;
    if (!map) return;

    function refreshMap(coordinates) {
      applyCareZoneMapState(map, heatProfile, userRange, productRange, coordinates);
    }

    resolveHeatMapCoordinates(heatProfile).then(function(coordinates) {
      maybePersistHeatMapCoordinates(heatProfile, coordinates);
      refreshMap(coordinates);
      return loadCareZoneMapPreview(map).then(function() {
        refreshMap(coordinates);
      });
    });
  }

  function shouldPortalComboPanel() {
    if (!window.matchMedia) return false;
    try {
      return window.matchMedia(MOBILE_PANEL_MEDIA).matches;
    } catch (error) {
      return false;
    }
  }

  function getPanelRestorePoint(combo, panel) {
    var summary = combo ? combo.querySelector('summary') : null;
    return {
      parent: combo,
      nextSibling: summary ? summary.nextSibling : combo.firstChild
    };
  }

  function syncBodyPanelLock() {
    var hasOpenPanel = Boolean(document.querySelector('[data-care-zone-panel-portaled="true"]:not([hidden])'));
    document.body.classList.toggle('care-zone-panel-open', hasOpenPanel);
  }

  function copyPanelThemeVars(combo, panel) {
    if (!combo || !panel || !window.getComputedStyle) return;
    var styles = window.getComputedStyle(combo);
    [
      '--zone-accent',
      '--zone-accent-soft',
      '--zone-accent-border',
      '--brand',
      '--brand-dark',
      '--ink',
      '--border',
      '--soft'
    ].forEach(function(name) {
      var value = styles.getPropertyValue(name);
      if (value) panel.style.setProperty(name, value.trim());
    });
  }

  function clearPanelViewportStyles(panel) {
    if (!panel) return;
    panel.style.removeProperty('left');
    panel.style.removeProperty('right');
    panel.style.removeProperty('max-height');
  }

  function clampDesktopComboPanel(combo) {
    var panel = getComboPanel(combo);
    if (!combo || !panel || !combo.open || shouldPortalComboPanel()) {
      clearPanelViewportStyles(panel);
      return;
    }

    clearPanelViewportStyles(panel);

    var margin = 16;
    var comboRect = combo.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    if (viewportWidth && panelRect.left < margin) {
      panel.style.right = 'auto';
      panel.style.left = Math.round(margin - comboRect.left) + 'px';
    } else if (viewportWidth && panelRect.right > viewportWidth - margin) {
      panel.style.left = 'auto';
      panel.style.right = Math.round(comboRect.right - (viewportWidth - margin)) + 'px';
    }

    if (viewportHeight) {
      panelRect = panel.getBoundingClientRect();
      var availableHeight = Math.floor(viewportHeight - Math.max(panelRect.top, margin) - margin);
      if (availableHeight > 0) {
        panel.style.maxHeight = availableHeight + 'px';
      }
    }
  }

  function restoreComboPanel(combo) {
    var panel = getComboPanel(combo);
    if (!combo || !panel) return;

    if (panel.parentNode !== combo) {
      var restorePoint = getPanelRestorePoint(combo, panel);
      combo.insertBefore(panel, restorePoint.nextSibling);
    }

    panel.hidden = false;
    panel.classList.remove('care-zone-combo__panel--portaled');
    panel.removeAttribute('data-care-zone-panel-portaled');
    panel.style.removeProperty('z-index');
    clearPanelViewportStyles(panel);
    syncBodyPanelLock();
  }

  function portalComboPanel(combo) {
    var panel = getComboPanel(combo);
    if (!combo || !panel) return;

    copyPanelThemeVars(combo, panel);
    clearPanelViewportStyles(panel);

    if (panel.parentNode !== document.body) {
      document.body.appendChild(panel);
    }

    panel.classList.add('care-zone-combo__panel--portaled');
    panel.setAttribute('data-care-zone-panel-portaled', 'true');
    panel.hidden = !combo.open;
    syncBodyPanelLock();
  }

  function syncComboPanelPortal(combo) {
    if (!combo) return;

    if (combo.open && shouldPortalComboPanel()) {
      portalComboPanel(combo);
      return;
    }

    restoreComboPanel(combo);
    if (combo.open) {
      clampDesktopComboPanel(combo);
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function() {
          clampDesktopComboPanel(combo);
        });
      }
    }
  }

  function bindPanelClose(combo, panel) {
    if (!combo || !panel || panel.getAttribute('data-care-zone-panel-close-bound') === 'true') return;
    panel.setAttribute('data-care-zone-panel-close-bound', 'true');

    panel.addEventListener('click', function(event) {
      var close = event.target && event.target.closest ? event.target.closest('[data-care-zone-close]') : null;
      if (!close) return;
      event.preventDefault();
      combo.open = false;
      syncComboPanelPortal(combo);
    });

    panel.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && combo.open) {
        combo.open = false;
        syncComboPanelPortal(combo);
      }
    });
  }

  function bindComboClose(combo) {
    if (!combo || combo.getAttribute('data-care-zone-close-bound') === 'true') return;
    combo.setAttribute('data-care-zone-close-bound', 'true');

    var summary = combo.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(event) {
        event.preventDefault();
        combo.open = !combo.open;
        syncComboPanelPortal(combo);
      });
    }

    combo.addEventListener('click', function(event) {
      var close = event.target && event.target.closest ? event.target.closest('[data-care-zone-close]') : null;
      if (!close) return;
      event.preventDefault();
      combo.open = false;
      syncComboPanelPortal(combo);
    });

    combo.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && combo.open) {
        combo.open = false;
        syncComboPanelPortal(combo);
      }
    });

    combo.addEventListener('toggle', function() {
      syncComboPanelPortal(combo);
    });

    window.addEventListener('resize', function() {
      syncComboPanelPortal(combo);
    }, { passive: true });
  }

  function removeLegacyZoneSelects(careGuide) {
    var legacySelects = careGuide.querySelectorAll('.care-zone-select');
    Array.prototype.forEach.call(legacySelects, function(select) {
      var control = select.closest ? select.closest('.care-zone-control') : null;
      var target = control || select;
      if (target.parentNode) target.parentNode.removeChild(target);
    });

    var legacyControls = careGuide.querySelectorAll('.care-zone-control');
    Array.prototype.forEach.call(legacyControls, function(control) {
      if (control.parentNode) control.parentNode.removeChild(control);
    });
  }

  function removeZoneDisplayNodes(careGuide) {
    var displays = queryCareGuideNodes(careGuide, '[data-care-zone-display]');
    Array.prototype.forEach.call(displays, function(display) {
      if (display.parentNode) display.parentNode.removeChild(display);
    });
  }

  function moveOrCreateZoneNode(zoneSummary, combo, selector, className, fallbackText) {
    var panel = getComboPanel(combo);
    var searchRoots = [zoneSummary, combo];
    if (panel && searchRoots.indexOf(panel) === -1) {
      searchRoots.push(panel);
    }

    var matches = [];
    searchRoots.forEach(function(root) {
      if (!root || !root.querySelectorAll) return;
      Array.prototype.forEach.call(root.querySelectorAll(selector), function(match) {
        if (matches.indexOf(match) === -1) matches.push(match);
      });
    });

    var node = matches[0];
    if (!node) {
      node = document.createElement('span');
      node.setAttribute(selector.slice(1, -1), '');
      node.textContent = fallbackText || '';
    } else if (matches.length > 1) {
      matches.slice(1).forEach(function(duplicate) {
        if (duplicate.parentNode) duplicate.parentNode.removeChild(duplicate);
      });
    }

    if (className) node.className = className;
    return node;
  }

  function ensureZoneSummary(careGuide) {
    var zoneSummary = careGuide.querySelector('.zone-summary');
    if (zoneSummary) return zoneSummary;

    var heroInner = careGuide.querySelector('.hero-inner');
    var heroCopy = findHeroCopy(heroInner);
    if (!heroCopy) return null;

    var shell = careGuide.querySelector('.care-zone-shell');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'care-zone-shell';

      var heading = heroCopy.querySelector('.hero-heading') || heroCopy.querySelector('h1');
      if (heading && heading.parentNode === heroCopy && heading.nextSibling) {
        heroCopy.insertBefore(shell, heading.nextSibling);
      } else {
        heroCopy.appendChild(shell);
      }
    }

    zoneSummary = document.createElement('div');
    zoneSummary.className = 'zone-summary';
    shell.appendChild(zoneSummary);
    return zoneSummary;
  }

  function ensureZoneCombo(careGuide) {
    var zoneSummary = ensureZoneSummary(careGuide);
    if (!zoneSummary) return null;

    var combo = zoneSummary.querySelector('[data-care-zone-combo]');
    if (!combo) {
      combo = document.createElement('details');
      combo.className = 'care-zone-combo';
      combo.setAttribute('data-care-zone-combo', '');

      var summary = document.createElement('summary');
      summary.className = 'care-zone-combo__summary';
      summary.setAttribute('aria-live', 'polite');

      var label = document.createElement('span');
      label.className = 'care-zone-combo__label';
      label.textContent = 'Current zone and heat index';

      var current = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-zone-current]', 'care-zone-combo__primary', 'Enter your ZIP code');
      var heatCurrent = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-heat-current]', 'care-zone-combo__meta', 'Heat index appears after ZIP lookup.');

      summary.appendChild(label);
      summary.appendChild(current);
      summary.appendChild(heatCurrent);
      combo.appendChild(summary);

      var oldEyebrow = zoneSummary.querySelector('.zone-summary__eyebrow');
      if (oldEyebrow && oldEyebrow.parentNode) oldEyebrow.parentNode.removeChild(oldEyebrow);

      zoneSummary.insertBefore(combo, zoneSummary.firstChild);
    }

    combo.classList.add('care-zone-combo');

    var comboSummary = combo.querySelector('summary');
    if (!comboSummary) {
      comboSummary = document.createElement('summary');
      combo.insertBefore(comboSummary, combo.firstChild);
    }
    comboSummary.classList.add('care-zone-combo__summary');
    comboSummary.setAttribute('aria-live', 'polite');

    if (!comboSummary.querySelector('.care-zone-combo__label')) {
      var comboLabel = document.createElement('span');
      comboLabel.className = 'care-zone-combo__label';
      comboLabel.textContent = 'Current zone and heat index';
      comboSummary.insertBefore(comboLabel, comboSummary.firstChild);
    }

    var comboCurrent = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-zone-current]', 'care-zone-combo__primary', 'Enter your ZIP code');
    var comboHeatCurrent = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-heat-current]', 'care-zone-combo__meta', 'Heat index appears after ZIP lookup.');
    if (comboCurrent.parentNode !== comboSummary) comboSummary.appendChild(comboCurrent);
    if (comboHeatCurrent.parentNode !== comboSummary) comboSummary.appendChild(comboHeatCurrent);

    removeZoneDisplayNodes(careGuide);
    var panel = ensureComboPanel(combo);
    var panelContent = panel ? panel.querySelector('[data-care-zone-panel-content]') : combo;

    var form = queryCareGuideNode(careGuide, '[data-care-zip-lookup]');
    if (!form) {
      form = createZipLookupControl(careGuide);
    }

    if (form.parentNode !== panelContent) {
      panelContent.appendChild(form);
    }

    var fit = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-zone-fit]', '', 'General care guidance.');
    var zoneCopy = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-zone-summary]', '', 'Enter your ZIP code to set your USDA zone and tune watering, sun, soil, and winter notes to your climate.');
    var heatCopy = moveOrCreateZoneNode(zoneSummary, combo, '[data-care-heat-summary]', '', 'For Zones 10 and warmer, your ZIP code separates lower-humidity western heat from humid heat.');

    [fit, zoneCopy, heatCopy].forEach(function(node) {
      if (node.parentNode !== panelContent) panelContent.appendChild(node);
    });

    ensureComboPanel(combo);

    return combo;
  }

  function ensureZipLookupControl(careGuide) {
    if (!careGuide) return;

    var combo = ensureZoneCombo(careGuide);
    if (queryCareGuideNode(careGuide, '[data-care-zip-input]')) return;

    var summary = careGuide.querySelector('.zone-summary');
    var shell = careGuide.querySelector('.care-zone-shell');
    var host = combo || summary || shell;
    if (!host) return;

    var form = createZipLookupControl(careGuide);
    if (combo) {
      combo.appendChild(form);
      return;
    }

    host.insertBefore(form, host.firstChild);
  }

  function syncZipLookupControls(careGuide, userRange) {
    ensureRuntimeStyles();
    ensureZipLookupControl(careGuide);

    var api = getZipApi();
    if (!api) return;

    var controls = queryCareGuideNodes(careGuide, '[data-care-zip-lookup]');
    Array.prototype.forEach.call(controls, function(control) {
      var input = control.querySelector('[data-care-zip-input]');
      var button = control.querySelector('[data-care-zip-submit]');
      var status = control.querySelector('[data-care-zip-status]');
      var suggestedZip = api.getSuggestedZip ? api.getSuggestedZip() : '';

      if (input && !input.value && suggestedZip) {
        input.value = suggestedZip;
      }

      if (control.getAttribute('data-care-zip-bound') === 'true') return;
      control.setAttribute('data-care-zip-bound', 'true');

      control.addEventListener('submit', function(event) {
        event.preventDefault();
        if (!input || !api.lookupZipClimate) return;

        var zip = api.normalizeZip(input.value);
        if (!zip) {
          setZipStatus(status, 'Enter a valid 5-digit ZIP code.', 'error');
          return;
        }

        if (button) {
          button.disabled = true;
          button.textContent = 'Checking...';
        }
        setZipStatus(status, 'Checking USDA zone and summer heat profile...', 'info');

        api.lookupZipClimate(zip, userRange, { source: 'manual' })
          .then(function(result) {
            setZipStatus(
              status,
              result.profileSaved
                ? 'Updated and saved to your profile from ZIP ' + result.zip + '.'
                : 'Updated from ZIP ' + result.zip + '.',
              'success'
            );
            initAll();
          })
          .catch(function() {
            setZipStatus(status, 'Could not check that ZIP code. Please try again.', 'error');
          })
          .then(function() {
            if (button) {
              button.disabled = false;
              button.textContent = 'Update';
            }
          });
      });
    });
  }

  function shouldAutoLookup(userRange, preference) {
    var suggestedZip = preference && typeof preference === 'object' ? preference.zip : preference;
    var suggestedSource = preference && typeof preference === 'object' ? preference.source : '';
    if (!suggestedZip) return false;

    var api = getZipApi();
    if (!api) return false;

    if (!userRange) return true;

    var savedHeatZip = api.getSavedHeatZip ? api.getSavedHeatZip() : '';
    var savedSource = api.getSavedHeatZipSource ? api.getSavedHeatZipSource() : '';
    if (suggestedSource === 'shipping') {
      return savedHeatZip !== suggestedZip || savedSource !== 'shipping';
    }

    var heatProfile = api.getSavedHeatProfile ? api.getSavedHeatProfile() : null;
    if (!heatProfile || !heatProfile.zip) return true;

    return savedHeatZip !== suggestedZip;
  }

  function maybeAutoLookupZip(userRange) {
    if (autoLookupStarted) return;
    var api = getZipApi();
    if (!api || typeof api.lookupZipClimate !== 'function') return;

    var preference = api.getInitialZipPreference
      ? api.getInitialZipPreference()
      : { zip: api.getSuggestedZip ? api.getSuggestedZip() : '', source: '' };
    var suggestedZip = preference.zip || '';
    if (!suggestedZip && !profileZipLookupStarted && typeof api.loadProfileZip === 'function') {
      profileZipLookupStarted = true;
      api.loadProfileZip()
        .then(function(profileZip) {
          if (profileZip) initAll();
        })
        .catch(function() {})
        .then(function() {
          profileZipLookupStarted = false;
        });
      return;
    }

    if (!shouldAutoLookup(userRange, preference)) return;

    autoLookupStarted = true;
    api.lookupZipClimate(suggestedZip, userRange, { source: preference.source || 'auto' })
      .then(function() {
        initAll();
      })
      .catch(function() {
        autoLookupStarted = false;
      });
  }

  function findHeroCopy(heroInner) {
    if (!heroInner) return null;

    var explicit = heroInner.querySelector('.hero-copy');
    if (explicit) return explicit;

    for (var i = 0; i < heroInner.children.length; i += 1) {
      var child = heroInner.children[i];
      var tagName = child.tagName ? child.tagName.toLowerCase() : '';
      if (tagName !== 'svg' && tagName !== 'img') return child;
    }

    return null;
  }

  function isHeroSubtitle(node) {
    return node
      && node.tagName
      && node.tagName.toLowerCase() === 'p';
  }

  function findHeroToc(heroCopy) {
    if (!heroCopy) return null;

    for (var i = 0; i < heroCopy.children.length; i += 1) {
      var child = heroCopy.children[i];
      if (child.classList && child.classList.contains('toc')) return child;
    }

    return null;
  }

  function removeHeroSubtitle(heading) {
    if (!heading) return;

    for (var i = heading.children.length - 1; i >= 0; i -= 1) {
      if (isHeroSubtitle(heading.children[i])) {
        heading.removeChild(heading.children[i]);
      }
    }
  }

  function normalizeHeroToc(heroCopy, heading) {
    if (!heroCopy || !heading || heading.querySelector('.toc')) return;

    var toc = findHeroToc(heroCopy);
    if (toc) {
      heading.appendChild(toc);
    }
  }

  function normalizeHeroHeading(root) {
    var heroInner = root.querySelector('.hero-inner');
    var heroCopy = findHeroCopy(heroInner);
    if (!heroCopy) return;

    var existingHeading = heroCopy.querySelector('.hero-heading');
    if (existingHeading) {
      removeHeroSubtitle(existingHeading);
      normalizeHeroToc(heroCopy, existingHeading);
      return;
    }

    var title = null;
    var description = null;
    var toc = null;

    for (var i = 0; i < heroCopy.children.length; i += 1) {
      var child = heroCopy.children[i];
      var tagName = child.tagName ? child.tagName.toLowerCase() : '';

      if (!title && tagName === 'h1') {
        title = child;
        continue;
      }

      if (title && !description && tagName === 'p') {
        description = child;
        continue;
      }

      if (title && !toc && child.classList && child.classList.contains('toc')) {
        toc = child;
      }
    }

    if (!title) return;

    var heading = document.createElement('div');
    heading.className = 'hero-heading';
    heroCopy.insertBefore(heading, title);
    heading.appendChild(title);

    if (description) {
      if (description.parentNode) {
        description.parentNode.removeChild(description);
      }
    }

    if (toc) {
      heading.appendChild(toc);
    }
  }

  function collectCareGuideRoots(root) {
    var careGuides = [];
    var selector = '[data-zone-care-guide], #mm-care-guide';

    function addCareGuide(node) {
      if (node && careGuides.indexOf(node) === -1) careGuides.push(node);
    }

    if (root.matches && root.matches(selector)) {
      addCareGuide(root);
    }

    Array.prototype.forEach.call(root.querySelectorAll(selector), addCareGuide);
    return careGuides;
  }

  function init(root) {
    if (!root || !root.querySelectorAll) return;

    var careGuides = collectCareGuideRoots(root);

    careGuides.forEach(function(careGuide) {
      careGuide.setAttribute('data-zone-care-guide', '');

      var userRange = parseStrictZoneInput(getSavedZone());
      var productRange = getProductRange(careGuide);
      var group = getZoneGroup(userRange, productRange);
      var state = describeState(group, userRange, productRange);
      var heatProfile = getSavedHeatProfile();
      var heatState = describeHeatState(userRange, heatProfile);

      normalizeHeroHeading(careGuide);
      removeLegacyZoneSelects(careGuide);
      ensureZoneCombo(careGuide);
      ensureHeatSummaryNode(careGuide);
      careGuide.setAttribute('data-active-zone-group', group);
      careGuide.setAttribute('data-user-zone', userRange ? userRange.display : '');
      careGuide.setAttribute('data-product-zone-range', productRange ? productRange.display : '');
      careGuide.setAttribute('data-heat-index-level', heatState.group);
      careGuide.setAttribute('data-heat-index-label', heatProfile && heatProfile.label ? heatProfile.label : '');

      setText(careGuide, '[data-care-zone-current]', state.current);
      setText(careGuide, '[data-care-zone-fit]', state.fit);
      setText(careGuide, '[data-care-zone-summary]', state.summary);
      setText(careGuide, '[data-care-heat-current]', heatState.current);
      setText(careGuide, '[data-care-heat-summary]', heatState.summary);
      syncZoneDisplay(careGuide, userRange);
      updateCopies(careGuide, group);
      updateHeatCopies(careGuide, heatState.group);
      updateHeatPanel(careGuide, userRange, heatState);
      syncZoneMapPreview(careGuide, heatProfile, userRange, productRange);
      syncZonePickerButtons(careGuide);
      syncZipLookupControls(careGuide, userRange);
      maybeAutoLookupZip(userRange);
    });
  }

  function initAll() {
    init(document);
  }

  window.MrMapleCareGuideZone = {
    version: '1.2.3',
    init: init,
    initAll: initAll,
    parseZoneRange: parseRange,
    getSavedZone: getSavedZone
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('garden:zone-updated', initAll);
  window.addEventListener('mrmaple:heat-profile-updated', initAll);
  window.addEventListener('storage', function(event) {
    var api = getZipApi();
    if (!api) return;

    if (
      api.STORAGE_KEYS.indexOf(event.key) !== -1 ||
      event.key === api.HEAT_PROFILE_STORAGE_KEY ||
      event.key === api.HEAT_ZIP_STORAGE_KEY
    ) {
      initAll();
    }
  });
  document.addEventListener('mm:care-guide-repositioned', initAll);
})();
